import { BookingTrackingTransporterDto, DeliveryTrackingDto } from '../dtos/tracking';
import { DriverDetails } from '../models/deliveries';
import { DeliveriesTracking } from '../models/deliveriesTracking';

export function dtoToCaptainDetails(deliveryTracking: DeliveryTrackingDto): DriverDetails | undefined {
  const captain = deliveryTracking?.captain;
  if (!captain) {
    return undefined;
  }
  return {
    driverName: captain.name,
    driverNumber: captain.phone_number,
    driverPicture: captain.image_url,
    notesToDriver: ''
  };
}

export function bookingTrackingTransporterDtoToDeliveriesTracking(
  deliveriesTracking: BookingTrackingTransporterDto[]
): DeliveriesTracking {
  if (!deliveriesTracking) {
    return {};
  }
  return deliveriesTracking.reduce((obj, item) => {
    const driverLocationDetails = item.location && {
      lat: item.location.latitude,
      lng: item.location.longitude
    };
    obj[item.booking_id] = { eta: item.eta ? item.eta?.duration : 1, driverLocationDetails: driverLocationDetails };
    return obj;
  }, {} as DeliveriesTracking);
}
